import { messages as toggleMessages } from './Toggle';
import { messages as languageMessages } from './Language';
import { messages as calendarMessages } from './CalendarAuth';

export const messages = {
  ...languageMessages,
  ...toggleMessages,
  ...calendarMessages,
};
